import { AuthenticatedDataRequest } from '@eggplant/data-request'
import { VAM_SERVICE } from '@eggplant/api-hosts'
import type { ReactNode } from 'react'

interface Props {
  children?: () => ReactNode
}

const PingVamService = ({
  children
}: Props) => {
  const url = `${VAM_SERVICE}/ping`

  return (
    <AuthenticatedDataRequest
      method='get'
      url={url}
    >
      {children}
    </AuthenticatedDataRequest>
  )
}

export default PingVamService
